import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import download from "../../asset/images/partner-download.svg";
import { toast } from "react-toastify";
import { Frenchisee } from "../../Configuration/Frenchisee_URL";
import UploadIcon from "../../asset/images/uploadImg-white.svg";
import infoIcon from "../../asset/images/information-circle.svg";
import iconError from "../../asset/images/alert-02.svg";
import { decryptData, encryptData, handleDownloadDocument, handleDownloadDocumentFrench, onlyNumber } from "../../CommonMethhods/CommonMethods";
import checkImge from "../../asset/images/check_circle_green.svg";
import SmallLoader from "../../Components/Common/smallLoader";
import docImage from "../../asset/images/photo-img.svg";
import deleteImg from "../../asset/images/delete-red.svg";
import eyeIcon from "../../asset/images/eyeIcon.svg";
import downloadbrokrage from '../../asset/images/download-brokrage.svg';
import { DOCUMENT_TYPE_MAP } from "../../CommonMethhods/Constants";
import axiosInstance from "../../CommonMethhods/axiosInstance";

function FrenchiseeDocumentDetailsPreview(props) {
    const storeToken = localStorage.getItem("ssoToken");
    let FrenchiseeId = localStorage.getItem("frenchiseeId");
    let navigate = useNavigate();
    let frenchiseeDatails = props.frenchiseeDatails;
    const [showModal, setShowModal] = useState(false);
    const [approveModal, setApproveModal] = useState(false);
    const [rejectionData, setRejectionData] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [selectedValue, setSelectedValue] = useState("");
    const [mtfBase, setMtfBase] = useState("");
    const [bfslSharing, setBfslSharing] = useState("");
    const [apSharingErr, setApSharingErr] = useState("");
    const [mtfErr, setMtfErr] = useState("");
    const [disposition, setDisposition] = useState("");
    const [cashValue, setCashValue] = useState("");
    const [stockValue, setStockValue] = useState("");
    const [remark, setRemark] = useState("");
    const [apShareErr, setApShareErr] = useState("");
    const [bfslShareErr, setBfslShareErr] = useState("");
    const [dispoErr, setDispoErr] = useState("");
    const [docErr, setDocErr] = useState("");
    const [remarkErr, setRemarkErr] = useState("");
    const [approvalDoc, setApprovalDoc] = useState("");
    const [stockErr, setStockErr] = useState("");
    const [cashErr, setCashErr] = useState("");
    const [reasonValid, setReasonValid] = useState(true);
    const [imageModal, setImageModal] = useState(false);
    // const [docError, setDocError] = useState("");
    const [image, setImage] = useState(null);
    const [fileType, setFileType] = useState("");
    const [docLoader, setDocLoader] = useState(false);
    const [allUrl, setAllUrl] = useState([]);
    const [selectedReasons, setSelectedReasons] = useState([]);
    const [rejectionRemarks, setRejectionRemarks] = useState("");
    const [rejectionRemarksError, setRejectionRemarksError] = useState("");
    const [comment, setComment] = useState("");
    const [commentErr, setCommentErr] = useState("");

    const userType = frenchiseeDatails?.userType;
    const isRP = userType === "RP"; 

    const [insuranceFixedDeposit, setInsuranceFixedDeposit] = useState("");
    const [pmsAifBonds, setPmsAifBonds] = useState("");
    const [mutualFund, setMutualFund] = useState("");
    const [investmentAdvisory, setInvestmentAdvisory] = useState("");
    const [unlistedShares, setUnlistedShares] = useState("");

    const [insuranceFixedDepositErr, setInsuranceFixedDepositErr] = useState("");
    const [pmsAifBondsErr, setPmsAifBondsErr] = useState("");
    const [mutualFundErr, setMutualFundErr] = useState("");
    const [investmentAdvisoryErr, setInvestmentAdvisoryErr] = useState("");
    const [unlistedSharesErr, setUnlistedSharesErr] = useState("");

    const handleComment = (e) => {
      let value = e.target.value;

      value = value.replace(/\s+/g, " ");
      value = value.replace(/^\s/, "");

      if (value.length > 250) {
        return;
      }

      setComment(value);

      if (value.trim()) {
        setCommentErr("");
      } else {
        setCommentErr("Remarks cannot be empty");
      }
    };
    
    const handleSharingChange = (value, setter, errorSetter) => {
       if (!/^\d*\.?\d{0,2}$/.test(value)) {
        return;
      }

      if (value === "") {
        setter("");
        errorSetter("");
        return;
      }

      const number = Number(value);
      if (number > 100) {
        return;
      }

      setter(value);

      if (number < 10) {
        errorSetter("Minimum value should be 10");
      } else if (number > 100) {
        errorSetter("Maximum value should be 100");
      } else {
        errorSetter("");
      }
    };

    const handleDecimalPaste = (e, maxLength, setter) => {
      e.preventDefault();

      const pasteData = e.clipboardData.getData("text").trim();

      // Allow 10-100 with up to 2 decimal places
      if (!/^(100(\.0{0,2})?|\d{1,2}(\.\d{0,2})?)$/.test(pasteData)) {
        return;
      }

      let value = pasteData.slice(0, maxLength);

      if (setter === setMtfBase && Number(value) > 50) return;
      if (setter === setSelectedValue && Number(value) > 100) return;

      setter(value);
    };

    const validateTPP = () => {
      let isValid = true;

      if (!insuranceFixedDeposit) {
        setInsuranceFixedDepositErr(
          "Insurance / Fixed Deposit sharing is required",
        );
        isValid = false;
      }

      if (!pmsAifBonds) {
        setPmsAifBondsErr("PMS / AIF Bonds sharing is required");
        isValid = false;
      }

      if (!mutualFund) {
        setMutualFundErr("Mutual Fund sharing is required");
        isValid = false;
      }

      if (!investmentAdvisory) {
        setInvestmentAdvisoryErr("Investment Advisory sharing is required");
        isValid = false;
      }

      if (!unlistedShares) {
        setUnlistedSharesErr("Unlisted Shares sharing is required");
        isValid = false;
      }

      return isValid;
    };

    const handleAccept = () => {
      const isTPPValid = validateTPP();
       if (!isTPPValid) {
        return;
      }
    };

    useEffect(() => {
      if (frenchiseeDatails) {
        setInsuranceFixedDeposit(frenchiseeDatails?.insuranceFixedDeposit || "",);
        setPmsAifBonds(frenchiseeDatails?.pmsAifBonds || "");
        setMutualFund(frenchiseeDatails?.mutualFund || "");
        setInvestmentAdvisory(frenchiseeDatails?.investmentAdvisory || "");
        setUnlistedShares(frenchiseeDatails?.unlistedShares || "");
      }
    }, [frenchiseeDatails]);

    const handleReasonChange = (e, item) => {
      const checked = e.target.checked;
      const id = item.id;

    //   console.log("checked", checked);
    //   console.log("id", id);

      if (checked) {
        setSelectedReasons((prev) => [...prev, id]);
      } else {
        setSelectedReasons((prev) =>
          prev.filter((reasonId) => reasonId !== id),
        );

        if (id === 17) {
          setRejectionRemarks("");
          setRejectionRemarksError("");
        }
      }
    };

    const isOthersSelected = selectedReasons.includes(17);

    const disableSubmit = !selectedReasons.length || (isOthersSelected && !rejectionRemarks.trim());
 

    const [documentData, setDocumentData] = useState({
        56: { name: "", isAvailable: false, url: "", type: "" },
    });

    useEffect(() => {
        const doc56 = frenchiseeDatails?.file?.find(
            (item) => item?.type == "56"
        );

        if (doc56) {
            setDocumentData({
                "56": {
                    name: doc56?.dfname || "",
                    isAvailable: true,
                    type: doc56?.type,
                    url: doc56?.url,
                },
            });
        } else {
            setDocumentData({});
        }
    }, [frenchiseeDatails]);

    console.log(frenchiseeDatails, "frenchiseeDatails");
    

    const isUploaded =
        documentData["56"]?.isAvailable;
    // frenchiseeDatails?.file?.some((item) => item?.type === "56");


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const onHide = () => {
        setShowModal(false);
        setSelectedFiles([])
    };

    console.log({ selectedReasons, rejectionRemarks, });
    const getRejectionReason = async () => {
        try {
            const getRejection = await axiosInstance.get(
                Frenchisee.REJECT_REASONS,
            );
            const data = decryptData(getRejection?.data);
            let dataResp = JSON.parse(data)
            if (dataResp?.status === 0) {
                setRejectionData(dataResp?.data?.rejectReasons);
            } else {
                toast.error(dataResp?.message)
            }
        } catch (error) {
            console.log(error);
            toast.error("Something went wrong");

        }
    };

    const rejectedUpdated = async () => {
        if (isOthersSelected && !rejectionRemarks.trim()) {
          setRejectionRemarksError("Please enter rejection reason.");
          return;
        }
        let rejPayload = {
            id: parseInt(FrenchiseeId),
            status: -2,
            reason: selectedReasons,
            rejectionRemarks: isOthersSelected ? rejectionRemarks : "",
        }
        let encyData = encryptData(JSON.stringify(rejPayload))

        try {
            const getStatus = await axiosInstance.put(
                Frenchisee.REJECTION_UPDATED,
                `${encyData}`,
            );
            const data = decryptData(getStatus.data);

            let dataResp = JSON.parse(data)
            if (dataResp?.status === 0) {
                toast.success(dataResp?.data?.message);
                setShowModal(false);
                navigate("/franchisee-onboarding");
            } else {
                setReasonValid(false);
                toast.error(dataResp?.message)
                setShowModal(true);
            }
        } catch (error) {
            console.log(error);
            toast.error("Something went wrong");

        }
    };

    // useEffect(() => {
    //     if (!reasonValid) {
    //         const checkboxes = document.querySelectorAll(".downloadSelect");
    //         checkboxes.forEach((checkbox) => {
    //             checkbox.checked = false;
    //         });
    //         setSelectedFiles([]); // Also clear selectedFiles from state
    //     }
    // }, [reasonValid]);

    const getValue = (e, type) => {
         let val = e.target.value.replace(/[^\d.]/g, "");
         const parts = val.split(".");
         if (parts.length > 2) {
           val = parts[0] + "." + parts.slice(1).join("");
         }
       val = val.slice(0, 6);

        if (type === "ap") {
            if (Number(val) > 100) return;
            // if (val > 100) {
            //     return;
            // }

            setSelectedValue(val);
            if (val === "") {
                setBfslSharing("");
                setApSharingErr("");
                return;
            }
            const numVal = Number(val);
            if (numVal < 0) {
                setApSharingErr("Please enter number between 0 and 100");
                setBfslSharing("");
            } else {
                setApSharingErr("");
                setBfslSharing((100 - numVal).toFixed(2));
            }
        }
        else {
            if (val > 50) return;
            setMtfBase(val);
            if (val === "") {
                setMtfErr("");
                return;
            }
            const numVal = Number(val);

            if (numVal < 9) {
                setMtfErr("Please enter number between 9 and 50");
            } else {
                setMtfErr("");
                setApShareErr("");
                setBfslShareErr("");
            }

        }
    };

    const handleDisposition = (e) => {
        const value = e?.target?.value;
        if (value) {
            setDisposition(value);
            setDispoErr("");
            setStockErr("");
            setCashErr("");
        }

        setCashValue("");
        setStockValue("");

    }

    const handleCashChange = (e) => {
        let val = e.target.value;

        if (val === "") {
            setCashValue("");
            setCashErr("");
            return;
        }

        val = Number(val);

        if (val > 200000) return;

        setCashValue(val);

        if (val < 10000) {
            setCashErr("Cash amount must be between 10000 and 200000");
        } else {
            setCashErr("");
        }
    };

    const handleStockChange = (e) => {
        let val = e.target.value;
        if (val === "") {
            setStockValue("");
            setStockErr("");
            return;
        }

        val = Number(val);
        if (val > 200000) return;
        setStockValue(val);
        if (val < 50000) {
            setStockErr("Stock amount must be between 50000 and 200000");
        } else {
            setStockErr("");
        }
    };

    const increaseValue = () => {
        let current = Number(selectedValue || 0);

        if (current < 100) {
            const newVal = current + 1;
            setSelectedValue(newVal);
            setBfslSharing(100 - newVal);
            setApSharingErr("");
        }
    };

    const decreaseValue = () => {
        let current = Number(selectedValue || 0);

        if (current > 0) {
            const newVal = current - 1;
            setSelectedValue(newVal);
            setBfslSharing(100 - newVal);
            setApSharingErr("");
        }
    };

    const approvedStatus = async () => {
        let approvePayload = {
            id: parseInt(FrenchiseeId),
            status: 2,
        }
        let payload = encryptData(JSON.stringify(approvePayload))
        try {
            const getStatus = await axiosInstance.put(
                Frenchisee.REJECTION_UPDATED,
                `${payload}`,
            );
            const data = decryptData(getStatus.data);
            let approveRes = JSON.parse(data)
            if (approveRes?.status === 0) {
                toast.success(approveRes?.data?.message);
                // setApproveModal(false)
                navigate("/franchisee-onboarding");
            } else {
                // setApproveModal(true);
            }
        } catch (error) {
            console.log(error);
            toast.error("Something went wrong");
        }
    };

    const downloadMultiple = (checked = true) => {
        const selectDownload = document.querySelectorAll(".downloadSelect");
        let selectArray = [];
        for (let item of selectDownload) {

            console.log(checked, "checked");
            if (checked) {
                if (item.checked === true) {
                    selectArray.push(parseInt(item.value));
                }
            } else {
                selectArray.push(item.value);
            }
        }
        setSelectedFiles(selectArray);
    };

    const getReason = () => {
        downloadMultiple();
        setReasonValid(true);
    };

    useEffect(() => {
        getRejectionReason();
        setSelectedFiles([]);
    }, []);

    const getApprovalData = async () => {
        let approvePayload = {
          id: parseInt(FrenchiseeId),
          apSharingCommBroking: Number(selectedValue || 0),
          bfslSharingCommBroking:
            bfslSharing !== "" && bfslSharing !== null
              ? Number(bfslSharing)
              : 0,
          mtfBaseRateCommMTF: isRP ? 0 : parseFloat(mtfBase),
          bfslSharingCommMTF: isRP ? 0 : 50,
          apSharingCommMTF: isRP ? 0 : 50,
          deposit: isRP ? "" : disposition,
          cash: isRP ? 0 : cashValue,
          stock: isRP ? 0 : disposition === "cash" ? 0 : stockValue,
          remarks: remark,
          comment: comment,
          insuranceFixedDeposit: Number(insuranceFixedDeposit || 0),
          pmsAifBonds: Number(pmsAifBonds || 0),
          mutualFund: Number(mutualFund || 0),
          investmentAdvisory: Number(investmentAdvisory || 0),
          unlistedShares: Number(unlistedShares || 0),
        };


        let payload = encryptData(JSON.stringify(approvePayload))

        try {
            const getApproval = await axiosInstance.put(
                Frenchisee.UPDATE_APPROVAL,
                payload,
            );
            const data = decryptData(getApproval?.data);
            let dataResp = JSON.parse(data)
            if (dataResp?.status === 0) {
                approvedStatus();
                // setRejectionData(dataResp?.data?.rejectReasons);
            } else {
                toast.error(dataResp?.message)
            }
        } catch (error) {
            console.log(error);
            toast.error("Something went wrong");

        }
    };

    const isFormValidForRP =
      selectedValue &&
      Number(selectedValue) >= 0 &&
      Number(selectedValue) <= 100 &&
      !!insuranceFixedDeposit &&
      !!pmsAifBonds &&
      !!mutualFund &&
      !!investmentAdvisory &&
      !!unlistedShares &&
      documentData["56"]?.isAvailable &&
      !!remark &&
      !remarkErr &&
      !!comment?.trim() &&
      !commentErr &&
      !apSharingErr &&
      !docErr &&
      !remarkErr &&
      !insuranceFixedDepositErr &&
      !pmsAifBondsErr &&
      !mutualFundErr &&
      !investmentAdvisoryErr &&
      !unlistedSharesErr;

    const isFormValidForAP =
      isFormValidForRP &&
      !!remark?.trim() &&
      mtfBase &&
      Number(mtfBase) >= 9 &&
      Number(mtfBase) <= 50 &&
      disposition &&
      (disposition === "cash" || stockValue) &&
      !!cashValue &&
      !mtfErr &&
      !dispoErr &&
      !stockErr &&
      !cashErr ;

    const handleApprovalBtn = () => {

        let isValid = true;

        if (
          selectedValue === "" ||
          selectedValue === null ||
          selectedValue === undefined
        ) {
          setApSharingErr("This field cannot be empty");
          isValid = false;
        } else if (selectedValue < 0 || selectedValue > 100) {
          setApSharingErr("Please enter number between 0 and 100");
          isValid = false;
        } else {
          setApSharingErr("");
        }

        
        if (!isRP) {
          if (!mtfBase) {
              setMtfErr("This field cannot be empty");
              setApShareErr("This field cannot be empty");
              setBfslShareErr("This field cannot be empty");
              isValid = false;
          }
          else if (mtfBase < 9 || mtfBase > 50) {
              setMtfErr("Please enter number between 9 and 50");
              isValid = false;
          }
          else {
              setMtfErr("");
              setApShareErr("");
              setBfslShareErr("");
          }

          if (!disposition) {
              setDispoErr("This field cannot be empty");
              isValid = false;
          } else {
              setDispoErr("");
          }
  
          if (disposition !== "cash" && !stockValue) {
              setStockErr("This field cannot be empty");
              isValid = false
          } else {
              setStockErr("");
          }
  
          if (!cashValue) {
              setCashErr("This field cannot be empty");
              isValid = false
          } else {
              setCashErr("");
          }
        }

        if (!documentData["56"]?.isAvailable) {
            setDocErr("Please upload document");
            isValid = false;
        } else {
            setDocErr("");
        }

        if (!isRP && !remark?.trim()) {
            setRemarkErr("This field cannot be empty");
            isValid = false;
        } else {
            setRemarkErr("");
        }

        console.log({isValid})
        if (isValid) {
            getApprovalData();
        }
    };

    const uploadeDocuments = async (e, type) => {
        setDocLoader(true);
        try {
            const formData = new FormData();

            formData.append("file", e?.target?.files[0]);
            formData.append("type", type);
            formData.append("fid", parseInt(FrenchiseeId));

            const getValue = await axiosInstance.post(
                Frenchisee.GetDocumentsList_Url,
                formData,
            );
            const response = decryptData(getValue?.data);
            let data = JSON.parse(response)

            if (data?.status === 0) {

                let object = {
                    name: e?.target?.files[0]?.name,
                    isAvailable: true,
                    type: type,
                    url: data?.data?.info?.url,
                };
                setDocumentData({ ...documentData, [type]: object });
                setApprovalDoc(e?.target?.files[0]);
            } else {
                toast.error(data?.message);
            }
        } catch (error) {
            console.log(error);
            toast.error("Something went wrong");
        } finally {
            setDocLoader(false);
        }
    };

    const handleImageUpload = (e, type1) => {
        if (e?.target?.files && e?.target?.files?.length > 0) {
            const file = e?.target?.files[0];

            const allowedExtensions = [
                "eml",
                "mbox",
                "vcf",
                "csv",
                "ics",
                "msg",
                "oft",
                "mht",
                "txt"
            ];

            if (file) {
                let size = Math.round(file.size / 1024);
                const fileExtension = file?.name.split(".").pop().toLowerCase();
                setFileType(fileExtension);
                // let fileExtension = file.name.split(".");
                const fileName = file?.name;

                if (size > 2048) {
                    setDocErr("File size should be 2MB or less than that.");
                    return;
                }

                // if (!["png", "jpeg", "jpg", "pdf"].includes(fileExtension)) {
                //     setDocErr("This file format is not supported.");
                //     return;
                // }

                if (!allowedExtensions.includes(fileExtension)) {
                    setDocErr("Only email-related file formats are allowed.");
                    return;
                }

                const specialCharRegex = /[^a-zA-Z0-9()._\s-]/;
                if (specialCharRegex.test(fileName)) {
                    setDocErr("Invalid file name.");
                    return;
                }

                setDocErr("");
                setImage(file);
                uploadeDocuments(e, type1);
            }
        }
    };

    const handleCloseModal = () => {
        setApSharingErr("");
        setMtfErr("")
        setApShareErr("");
        setBfslShareErr("");
        setDispoErr("");
        setDocErr("");
        setRemarkErr("");
        setCommentErr("");
        setStockErr("");
        setCashErr("");

        setMtfBase("");
        setSelectedValue("");
        setBfslSharing("");
        setDisposition("");
        setRemark("");
        setComment("");
        setStockValue("");
        setCashValue("");
        setApproveModal(false);

        setInsuranceFixedDeposit("");
        setInsuranceFixedDepositErr("");
        setMutualFund("");
        setMutualFundErr("");
        setPmsAifBonds("");
        setPmsAifBondsErr("");
        setInvestmentAdvisory("");
        setInvestmentAdvisoryErr("");
        setUnlistedShares("");
        setUnlistedSharesErr("");
    }

    const deleteDocuments = async (data) => {
        try {
            const getDeleteData = await axiosInstance.delete(
                `${Frenchisee.GetDocumentsList_Url}?fid=${FrenchiseeId}&fileType=${data}`,
            );

            const deletedData = decryptData(getDeleteData?.data);
                let deletedResp = JSON.parse(deletedData)

            if (deletedResp?.status === 0) {
                toast.success(deletedResp?.data?.message);

                let object = { [data]: { name: "", isAvailable: false, type: data, url: "" } };
                setDocumentData({ ...documentData, ...object });
                
                setApprovalDoc(null);

                const fileInput = document.getElementById("approvalFile");
                if (fileInput) fileInput.value = "";
            } else {
                toast.error(deletedResp?.message);
            }
        } catch (error) {
            console.log(error);
            toast.error("Something went wrong");
        }
    };

    const deleteDoc = (data) => {
        deleteDocuments(data);
    };

    // const handleFileChange = (e) => {
    //     const type = 56;
    //     handleImageUpload(e, type);
    // };

    const handleRemark = (e) => {
      // setRemark(e.target.value);
      // setRemarkErr("");
  const value = e.target.value;

  if (value === "" || Number(value) <= 400000) {
    setRemark(value);
    setRemarkErr("");
  } else {
    setRemarkErr("Balance cannot exceed ₹4,00,000 - Please re-enter the value");
  }
};

    const handleNumberPaste = (e, maxLength, setter) => {
        e.preventDefault();

        const pasteData = e.clipboardData.getData("text");
        let numbersOnly = pasteData.replace(/\D/g, "");
        if (!numbersOnly) return;
        numbersOnly = numbersOnly.slice(0, maxLength);
        if (setter === setMtfBase && Number(numbersOnly) > 50) return;
        if (setter === setSelectedValue && Number(numbersOnly) > 100) return;
        setter(numbersOnly);
    };

    const downloadAllDoc = async (data) => {

        try {
            const getAllData = await axiosInstance.get(
                `${Frenchisee.Download_AllDoc}?fid=${FrenchiseeId}`,
            );

            const getData = decryptData(getAllData?.data);
            let response = JSON.parse(getData)

            console.log(response?.data, "response98766");
            if (response?.status === 0) {
                let files = response?.data;
                window.open(files, "_self", "noopener,noreferrer");
            }
            else {
                toast?.error(response?.message)
            }

        } catch (error) {
            console.log(error);
            toast.error("Something went wrong");
        }
    };

    const handleDownloadBtn = () => {
        downloadAllDoc()
    }

    const moveCursorToNumberEnd = (e) => {
        const val = e.target.value;

        if (!val) return;

        const position = val.includes("%") ? val.length - 1 : val.length;

        setTimeout(() => {
            e.target.setSelectionRange(position, position);
        }, 0);
        };

      const isValid =  isRP ? !isFormValidForRP : !isFormValidForAP;


    return (
      <>
        <div className="card-box">
          <div className="card-title">
            <h2 className="">Document</h2>
            <span
              className="download-btn-franch"
              onClick={() => handleDownloadBtn()}
            >
              <img
                src={download}
                alt=""
                className="download-img partner-down"
              />
              Download All
            </span>
          </div>

          <div className="">
            <div className="">
              <div className="row imgWrapper">
                {frenchiseeDatails &&
                  frenchiseeDatails.file?.map((item) => {
                    const fileName = item.fname || item.dfname || "";
                    const fileExt = fileName.split(".").pop()?.toLowerCase();
                    const isPdf = fileExt === "pdf";
                    const isImage = !["pdf", "csv", "txt", "eml", "mbox", "vcf", "ics", "msg", "oft", "mht"].includes(
                      fileExt,
                    );

                    return (
                      <div key={item.id} className="col-md-6 bottom-25">
                        <p className="pdf-label">
                          {DOCUMENT_TYPE_MAP[item?.type] || ""}
                        </p>

                        <div className="document-wrapper">
                          {isPdf ? (
                            <iframe
                              src={item.url}
                              className="document-pdf partner-down"
                              title="frame"
                            />
                          ) : isImage ? (
                            <img
                              src={item?.url}
                              className="document-img"
                              alt="document-img"
                            />
                          ) : (
                            <div className="document-img document-generic-file">
                              <img
                                src={docImage}
                                alt="document-file"
                                className="generic-file-icon"
                              />
                            </div>
                          )}
                          <img
                            src={download}
                            alt=""
                            className="download-img partner-down"
                            onClick={() => {
                              handleDownloadDocumentFrench(
                                item?.url,
                                item?.dfname,
                                item?.type,
                              );
                            }}
                          />
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
          {frenchiseeDatails?.statusId === 1 ? (
            <div className="partner-btn">
              <div>
                <button
                  className="back-btn"
                  type="submit"
                  onClick={() => {
                    navigate("/franchisee-onboarding");
                  }}
                >
                  Back
                </button>
              </div>

              <div>
                <button
                  className="rej-btn"
                  type="submit"
                  onClick={() => setShowModal(true)}
                >
                  Reject
                </button>
              </div>
              <div>
                <button
                  className="appro-btn"
                  type="submit"
                  onClick={() => setApproveModal(true)}
                >
                  Upload
                  <img
                    src={UploadIcon}
                    alt="upload"
                    className="down-icon cursor-pointer upload-btns"
                  />
                </button>
              </div>
            </div>
          ) : (
            <div>
              <button
                className="back-btn"
                type="submit"
                onClick={() => {
                  navigate("/franchisee-onboarding");
                }}
              >
                Back
              </button>
            </div>
          )}
        </div>

        <Modal
          show={approveModal}
          onHide={onHide}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="setting-model partner-modal-rejection fran-aprove"
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header>
            <Modal.Title id="contained-modal-title-vcenter">
              <h2 className="model-title">
                {userType} Commercials Brokings
              </h2>
            </Modal.Title>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={handleCloseModal}
            >
              <span className="icon-close"></span>
            </button>
          </Modal.Header>
          <Modal.Body>
            <div className="client-info-status ap-commercial-modal">
              <ul className="call-web-wrapper disposition-wrapper ap-commercial">
                <li className="disposition-select-back">
                  <div>
                    <label htmlFor="" className="form-text">
                      {userType} Sharing
                      <span style={{ color: "red" }}>*</span>
                    </label>

                    <div className="input-arrow-wrapper">
                      <input
                        className="ap-sharing-input"
                        type="text"
                        placeholder="Enter Percentage"
                        min="0"
                        max="100"
                        onInput={onlyNumber}
                        maxLength={6}
                        value={
                          selectedValue !== ""
                            ? Number(selectedValue) >= 0
                              ? `${selectedValue}%`
                              : selectedValue
                            : ""
                        }
                        // value={selectedValue || ""}
                        onChange={(e) => getValue(e, "ap")}
                        onPaste={(e) =>
                          handleDecimalPaste(e, 5, setSelectedValue)
                        }
                        onFocus={(e) => moveCursorToNumberEnd(e)}
                        onClick={(e) => moveCursorToNumberEnd(e)}
                        onKeyUp={(e) => moveCursorToNumberEnd(e)}
                      />

                      <div className="arrow-buttons">
                        <span onClick={increaseValue}>▲</span>
                        <span onClick={decreaseValue}>▼</span>
                      </div>
                    </div>
                    {apSharingErr && (
                      <div className="err-wrap-franch">
                        <img src={iconError} alt="err-icon" />
                        <span className="common-err franchisee-err">
                          {apSharingErr}
                        </span>
                      </div>
                    )}
                  </div>
                </li>
                <li className="disposition-select-back">
                  <div>
                    <label htmlFor="" className="form-text">
                      BFSL Sharing
                    </label>

                    <input
                      name="partner-source"
                      disabled
                      placeholder="Enter Percentage"
                      id="calculate-val"
                      // value={bfslSharing ? `${bfslSharing}%` : ""}
                      value={
                        bfslSharing !== "" &&
                        bfslSharing !== null &&
                        bfslSharing !== undefined
                          ? `${bfslSharing}%`
                          : ""
                      }
                    />
                  </div>
                </li>
              </ul>
            </div>

            {userType === "AP" && (
              <>
                <div className="client-info-status ap-commercial-modal franch-approval">
                  <h6 className="commercial-head">AP Commercials MTF</h6>
                  <ul className="call-web-wrapper disposition-wrapper ap-commercial ap-mtf">
                    <li className="disposition-select-back mtf-rate">
                      <div>
                        <label htmlFor="" className="form-text">
                          MTF Base Rate
                          <span style={{ color: "red" }}>*</span>
                        </label>

                        <div className="input-arrow-wrapper">
                          <input
                            className="ap-sharing-input"
                            type="text"
                            min="9"
                            max="50"
                            // onInput={onlyNumber}
                            maxLength={6}
                            placeholder="Enter Percentage"
                            value={
                              mtfBase !== ""
                                ? Number(mtfBase) >= 9
                                  ? `${mtfBase}%`
                                  : mtfBase
                                : ""
                            }
                            onChange={(e) => getValue(e, "mtf")}
                            onPaste={(e) => handleDecimalPaste(e, 4, setMtfBase)}
                            onFocus={(e) => moveCursorToNumberEnd(e)}
                            onClick={(e) => moveCursorToNumberEnd(e)}
                            onKeyUp={(e) => moveCursorToNumberEnd(e)}
                          />

                          {/* <div className="arrow-buttons">
                                        <span onClick={increaseValue}>▲</span>
                                        <span onClick={decreaseValue}>▼</span>
                                    </div> */}
                        </div>
                        {!mtfErr && (
                          <span className="wrap-info">
                            <img src={infoIcon} alt="info-icons" />
                            MTF Sharing above base rate is 50%
                          </span>
                        )}
                        {mtfErr && (
                          <div className="err-wrap-franch">
                            <img src={iconError} alt="err-icon" />
                            <span className="common-err franchisee-err">
                              {mtfErr}
                            </span>
                          </div>
                        )}
                      </div>
                    </li>
                  </ul>
                </div>

                <div className="client-info-status ap-commercial-modal">
                  <ul className="call-web-wrapper disposition-wrapper ap-commercial ap-mtf">
                    <li className="disposition-select-back">
                      <div>
                        <label htmlFor="" className="form-text">
                          AP Sharing
                          <span style={{ color: "red" }}>*</span>
                        </label>

                        <input
                          type="text"
                          disabled
                          placeholder="Enter Percentage"
                          value={mtfBase?.length > 0 ? "50%" : ""}
                        />
                      </div>
                      {apShareErr && (
                        <div className="err-wrap-franch">
                          <img src={iconError} alt="err-icon" />
                          <span className="common-err franchisee-err">
                            {apShareErr}
                          </span>
                        </div>
                      )}
                    </li>

                    <li className="disposition-select-back">
                      <div>
                        <label htmlFor="" className="form-text">
                          BFSL Sharing
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="Enter Percentage"
                          disabled
                          value={mtfBase?.length > 0 ? "50%" : ""}
                        />
                      </div>
                      {bfslShareErr && (
                        <div className="err-wrap-franch">
                          <img src={iconError} alt="err-icon" />
                          <span className="common-err franchisee-err">
                            {bfslShareErr}
                          </span>
                        </div>
                      )}
                    </li>
                  </ul>
                  {/* <div className="err-handle">
                        <span className="mtf-info">
                        <span className="icon-info-icon info"></span>
                            MTF sharing to be done over and above base rate
                        </span>
                    </div> */}
                </div>

                <div className="client-info-status ap-commercial-modal">
                  <ul className="call-web-wrapper disposition-wrapper ap-commercial ap-mtf">
                    <li className="disposition-select-back mtf-rate">
                      <div>
                        <label htmlFor="" className="form-text">
                          Deposit
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <select
                          id="mtf-data"
                          value={disposition}
                          onChange={handleDisposition}
                        >
                          <option value="">Select Deposit</option>
                          <option value="stock-cash">Stock & Cash</option>
                          <option value="cash">Cash</option>
                        </select>
                        {dispoErr && (
                          <div className="err-wrap-franch">
                            <img src={iconError} alt="err-icon" />
                            <span className="common-err franchisee-err">
                              {dispoErr}
                            </span>
                          </div>
                        )}
                      </div>
                    </li>
                  </ul>
                </div>

                {disposition && (
                  <div className="client-info-status ap-commercial-modal">
                    <ul className="call-web-wrapper disposition-wrapper ap-commercial ap-mtf">
                      <li className="disposition-select-back">
                        <div className="stock-text-wrapper">
                          <label htmlFor="" className="form-text">
                            Stock
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          {disposition !== "cash" && (
                            <span className="gray-text-val">
                              Min 50000 - Max 200000
                            </span>
                          )}
                        </div>
                        <input
                          type="text"
                          value={disposition === "cash" ? "0" : stockValue}
                          onChange={handleStockChange}
                          disabled={disposition === "cash"}
                          min="50000"
                          max="200000"
                          maxLength={6}
                          onInput={onlyNumber}
                          placeholder="Enter Stock Amount"
                          onPaste={(e) =>
                            handleNumberPaste(e, 6, setStockValue)
                          }
                        />
                        {stockErr && (
                          <div className="err-wrap-franch">
                            <img src={iconError} alt="err-icon" />
                            <span className="common-err franchisee-err">
                              {stockErr}
                            </span>
                          </div>
                        )}
                      </li>

                      <li className="disposition-select-back">
                        <div className="stock-text-wrapper">
                          <label htmlFor="" className="form-text">
                            Cash
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <span className="gray-text-val">
                            Min 10000 - Max 200000
                          </span>
                        </div>

                        <input
                          type="text"
                          value={cashValue}
                          onChange={handleCashChange}
                          min="10000"
                          max="200000"
                          maxLength={6}
                          onInput={onlyNumber}
                          placeholder="Enter Cash Amount"
                          onPaste={(e) => handleNumberPaste(e, 6, setCashValue)}
                        />
                        {cashErr && (
                          <div className="err-wrap-franch">
                            <img src={iconError} alt="err-icon" />
                            <span className="common-err franchisee-err">
                              {cashErr}
                            </span>
                          </div>
                        )}
                      </li>
                    </ul>
                  </div>
                )}
              </>
            )}

            <div className="tpp-section">
              <h3 className="tpp-section_title">
                TPP Sharing
              </h3>

              <ul className="tpp-section_wrapper">
                <li className="tpp-section_wrapper_list">
                  <div className="tpp-section_wrapper_list_field">
                    <label className="form-text tpp-section_wrapper_list_field_label">
                      Insurance, Fixed Deposit %
                      <span style={{ color: "red" }}>*</span>
                    </label>

                    <input
                      type="text"
                      className="form-control tpp-section_wrapper_list_field_input"
                      value={
                        insuranceFixedDeposit !== ""
                          ? Number(insuranceFixedDeposit) >= 10
                            ? `${insuranceFixedDeposit}%`
                            : insuranceFixedDeposit
                          : ""
                      }
                      maxLength={6}
                      placeholder="Enter Percentage"
                      onInput={onlyNumber}
                      onChange={(e) =>
                        handleSharingChange(
                          e.target.value,
                          setInsuranceFixedDeposit,
                          setInsuranceFixedDepositErr,
                        )
                      }
                      onFocus={(e) => moveCursorToNumberEnd(e)}
                      onClick={(e) => moveCursorToNumberEnd(e)}
                      onKeyUp={(e) => moveCursorToNumberEnd(e)}
                    />

                    {insuranceFixedDepositErr && (
                      <div className="err-wrap-franch">
                        <img src={iconError} alt="err-icon" />
                        <span className="common-err franchisee-err">
                          {insuranceFixedDepositErr}
                        </span>
                      </div>
                    )}
                  </div>
                </li>

                <li className="tpp-section_wrapper_list">
                  <div>
                    <label className="form-text tpp-section_wrapper_list_field_label">
                      PMS / AIF, Bonds %<span style={{ color: "red" }}>*</span>
                    </label>

                    <input
                      type="text"
                      className="form-control tpp-section_wrapper_list_field_input"
                      value={
                        pmsAifBonds !== ""
                          ? Number(pmsAifBonds) >= 10
                            ? `${pmsAifBonds}%`
                            : pmsAifBonds
                          : ""
                      }
                      maxLength={6}
                      placeholder="Enter Percentage"
                      onInput={onlyNumber}
                      onChange={(e) =>
                        handleSharingChange(
                          e.target.value,
                          setPmsAifBonds,
                          setPmsAifBondsErr,
                        )
                      }
                      onFocus={(e) => moveCursorToNumberEnd(e)}
                      onClick={(e) => moveCursorToNumberEnd(e)}
                      onKeyUp={(e) => moveCursorToNumberEnd(e)}
                    />

                    {pmsAifBondsErr && (
                      <div className="err-wrap-franch">
                        <img src={iconError} alt="err-icon" />
                        <span className="common-err franchisee-err">
                          {pmsAifBondsErr}
                        </span>
                      </div>
                    )}
                  </div>
                </li>

                <li className="tpp-section_wrapper_list">
                  <div>
                    <label className="form-text tpp-section_wrapper_list_field_label">
                      Mutual Fund %<span style={{ color: "red" }}>*</span>
                    </label>

                    <input
                      type="text"
                      className="form-control tpp-section_wrapper_list_field_input"
                      value={
                        mutualFund !== ""
                          ? Number(mutualFund) >= 10
                            ? `${mutualFund}%`
                            : mutualFund
                          : ""
                      }
                      maxLength={6}
                      placeholder="Enter Percentage"
                      onInput={onlyNumber}
                      onChange={(e) =>
                        handleSharingChange(
                          e.target.value,
                          setMutualFund,
                          setMutualFundErr,
                        )
                      }
                      onFocus={(e) => moveCursorToNumberEnd(e)}
                      onClick={(e) => moveCursorToNumberEnd(e)}
                      onKeyUp={(e) => moveCursorToNumberEnd(e)}
                    />

                    {mutualFundErr && (
                      <div className="err-wrap-franch">
                        <img src={iconError} alt="err-icon" />
                        <span className="common-err franchisee-err">
                          {mutualFundErr}
                        </span>
                      </div>
                    )}
                  </div>
                </li>

                <li className="tpp-section_wrapper_list">
                  <div>
                    <label className="form-text tpp-section_wrapper_list_field_label">
                      Investment Advisory %
                      <span style={{ color: "red" }}>*</span>
                    </label>

                    <input
                      type="text"
                      className="form-control tpp-section_wrapper_list_field_input"
                      value={
                        investmentAdvisory !== ""
                          ? Number(investmentAdvisory) >= 10
                            ? `${investmentAdvisory}%`
                            : investmentAdvisory
                          : ""
                      }
                      maxLength={6}
                      placeholder="Enter Percentage"
                      onInput={onlyNumber}
                      onChange={(e) =>
                        handleSharingChange(
                          e.target.value,
                          setInvestmentAdvisory,
                          setInvestmentAdvisoryErr,
                        )
                      }
                      onFocus={(e) => moveCursorToNumberEnd(e)}
                      onClick={(e) => moveCursorToNumberEnd(e)}
                      onKeyUp={(e) => moveCursorToNumberEnd(e)}
                    />

                    {investmentAdvisoryErr && (
                      <div className="err-wrap-franch">
                        <img src={iconError} alt="err-icon" />
                        <span className="common-err franchisee-err">
                          {investmentAdvisoryErr}
                        </span>
                      </div>
                    )}
                  </div>
                </li>

                <li className="tpp-section_wrapper_list">
                  <div>
                    <label className="form-text tpp-section_wrapper_list_field_label">
                      Unlisted Shares %<span style={{ color: "red" }}>*</span>
                    </label>

                    <input
                      type="text"
                      className="form-control tpp-section_wrapper_list_field_input"
                      value={
                        unlistedShares !== ""
                          ? Number(unlistedShares) >= 10
                            ? `${unlistedShares}%`
                            : unlistedShares
                          : ""
                      }
                      maxLength={6}
                      placeholder="Enter Percentage"
                      onInput={onlyNumber}
                      onChange={(e) =>
                        handleSharingChange(
                          e.target.value,
                          setUnlistedShares,
                          setUnlistedSharesErr,
                        )
                      }
                      onFocus={(e) => moveCursorToNumberEnd(e)}
                      onClick={(e) => moveCursorToNumberEnd(e)}
                      onKeyUp={(e) => moveCursorToNumberEnd(e)}
                    />

                    {unlistedSharesErr && (
                      <div className="err-wrap-franch">
                        <img src={iconError} alt="err-icon" />
                        <span className="common-err franchisee-err">
                          {unlistedSharesErr}
                        </span>
                      </div>
                    )}
                  </div>
                </li>
              </ul>
            </div>

            <div className="upload-section">
              <div className="upload-wrapper-franch">
                <div>
                  <label>
                    Upload Approval Letter
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  {documentData["56"]?.isAvailable && (
                    <>
                      <span className="upload-text">
                        Uploaded
                        <img src={checkImge} alt="checkimage" />
                      </span>

                      <div className="check-image">
                        <span className="file-wrap">
                          <img src={docImage} alt="document-pic" />
                          <label
                            className="img-name"
                            title={documentData["56"]?.name || image?.name}
                          >
                            {documentData["56"]?.name || image?.name}
                          </label>
                        </span>

                        <div className="wrap-del-preview">
                          <button
                            type="button"
                            onClick={() => deleteDoc("56")}
                            className="del-btn"
                          >
                            <img src={deleteImg} alt="delete icon" />
                            Delete
                          </button>

                          <div className="preview-text">
                            {(() => {
                              const fileName = documentData["56"]?.name || "";
                              const fileUrl = documentData["56"]?.url;
                              const fileExt = fileName
                                .split(".")
                                .pop()
                                ?.toLowerCase();

                              const previewableTypes = ["txt"];
                              const isPreviewable =
                                previewableTypes.includes(fileExt);

                              return isPreviewable ? (
                                // ✅ SHOW PREVIEW BUTTON
                                <span
                                  className="icon-text"
                                  role="button"
                                  onClick={() => setImageModal(true)}
                                >
                                  <img src={eyeIcon} alt="eye icon" />
                                  Preview
                                </span>
                              ) : (
                                <a href={fileUrl} rel="noreferrer" download>
                                  <img
                                    src={downloadbrokrage}
                                    alt="download icon"
                                  />
                                  Download
                                </a>
                              );
                            })()}
                          </div>

                          {/* <div className="preview-text">
                                                    <span
                                                        className="icon-text"
                                                        type="button"
                                                        onClick={() =>
                                                            setImageModal(true)
                                                        }
                                                    >
                                                        <img
                                                            src={eyeIcon}
                                                            alt="eye icon"
                                                        />
                                                        Preview
                                                    </span>
                                                </div> */}
                        </div>
                      </div>
                    </>
                  )}
                </div>

                <div className="upload-btn-wrap">
                  <input
                    type="file"
                    id="approvalFile"
                    name="approvalFile"
                    // accept="image/png,image/jpeg,image/jpg, application/pdf"
                    accept=".eml,.mbox,.vcf,.csv,.ics,.msg,.oft,.mht,.txt"
                    className="file-input-hidden"
                    onChange={(e) => handleImageUpload(e, 56)}
                    key={image?.name || ""}
                    disabled={documentData["56"]?.isAvailable}
                  />
                  {documentData["56"]?.isAvailable ? (
                    <label className="disable-btn-file">Choose File</label>
                  ) : (
                    <label htmlFor="approvalFile" className="choose-file-btn">
                      {docLoader ? <SmallLoader /> : <>Choose File</>}
                    </label>
                  )}
                </div>
              </div>
              {docErr && (
                <div className="err-wrap-franch">
                  <img src={iconError} alt="err-icon" />
                  <span className="common-err franchisee-err">{docErr}</span>
                </div>
              )}

              <div className="upload-instruction">
                <span className="format-info">
                  Note: Please upload email-related files only (.eml, .mbox,
                  .vcf, .csv, .ics, .msg, .oft, .mht, .txt). Max size: 2MB
                  {/* Note: Please upload document in .pdf, .jpg, .jpeg, .png format. Documents in .pdf, .jpg, .jpeg, .png format must have max size of 2MB */}
                </span>
              </div>
            </div>

            <div className="client-info-status ap-commercial-modal">
              <ul className="call-web-wrapper disposition-wrapper ap-commercial ap-mtf">
                <li className="disposition-select-back mtf-rate">
                  <div>
                    <label htmlFor="" className="form-text">
                      Balance Amount
                      <span style={{ color: "red" }}>*</span>
                    </label>

                    <div className="input-arrow-wrapper">
                      <input
                        className="ap-sharing-input"
                        type="text"
                        max={400000}
                        min={0}
                        value={remark}
                        onChange={handleRemark}
                        placeholder="Enter balance"
                        maxLength={6}
                        onInput={onlyNumber}
                        onPaste={(e) => handleNumberPaste(e, 6, setRemark)}
                      />
                    </div>

                    {remarkErr && (
                      <div className="err-wrap-franch">
                        <img src={iconError} alt="err-icon" />
                        <span className="common-err franchisee-err">
                          {remarkErr}
                        </span>
                      </div>
                    )}
                  </div>
                </li>
              </ul>
            </div>

            <div className="client-info-status ap-commercial-modal">
              <ul className="call-web-wrapper disposition-wrapper ap-commercial ap-mtf">
                <li className="disposition-select-back mtf-rate">
                  <div>
                    <label htmlFor="" className="form-text">
                      Remarks
                      <span style={{ color: "red" }}>*</span>
                    </label>

                    <div className="input-arrow-wrapper">
                      <input
                        className="ap-sharing-input"
                        type="text"
                        value={comment}
                        onChange={handleComment}
                        placeholder="Enter remarks"
                        maxLength={250}
                      />
                    </div>

                    {commentErr && (
                      <div className="err-wrap-franch">
                        <img src={iconError} alt="err-icon" />
                        <span className="common-err franchisee-err">
                          {commentErr}
                        </span>
                      </div>
                    )}
                  </div>
                </li>
              </ul>
            </div>

            <button
              type="submit"
              className={`${isValid ? "disable-btn-approve" : "approve-btn"}`}
              disabled={isValid}
              onClick={() => handleApprovalBtn()}
            >
              APPROVE
            </button>
          </Modal.Body>
        </Modal>

        <Modal
          show={showModal}
          onHide={onHide}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="setting-model partner-modal-rejection"
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header>
            <Modal.Title id="contained-modal-title-vcenter">
              <h2 className="model-title">Rejection Selection</h2>
            </Modal.Title>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={onHide}
            >
              <span className="icon-close"></span>
            </button>
          </Modal.Header>
          <Modal.Body>
            <ul className="partner-ul">
              {rejectionData &&
                rejectionData?.map((item) => {
                  return (
                    <li key={item.id}>
                      <input
                        type="checkbox"
                        id={`reason-${item.id}`}
                        value={item.id}
                        className="downloadSelect"
                        onChange={(e) => handleReasonChange(e, item)}
                      />
                      <label htmlFor={`reason-${item.id}`}>{item.reason}</label>
                    </li>
                  );
                })}
              {/* </select> */}
            </ul>

            {isOthersSelected && (
              <div style={{ marginTop: "15px", marginBottom: "20px" }}>
                <textarea
                  className="form-control other-remark-textarea"
                  rows={4}
                  placeholder="Please put your rejection reason here"
                  value={rejectionRemarks}
                  onChange={(e) => {
                    setRejectionRemarks(e.target.value);

                    if (e.target.value.trim()) {
                      setRejectionRemarksError("");
                    }
                  }}
                />

                {rejectionRemarksError && (
                  <p
                    style={{
                      color: "red",
                      fontSize: "12px",
                      marginTop: "5px",
                      marginBottom: "0px",
                    }}
                  >
                    {rejectionRemarksError}
                  </p>
                )}
              </div>
            )}

            <div className="d-flex justify-content-end">
              <button
                type="submit"
                className={!disableSubmit ? "rej-btn" : "disabled-file"}
                disabled={disableSubmit}
                onClick={() => rejectedUpdated()}
              >
                Submit
              </button>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={imageModal}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="ifscModal preview-modal"
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => setImageModal(false)}
            >
              <span className="icon-close"></span>
            </button>
          </Modal.Header>
          <Modal.Body>
            <form className="modal-form select-new">
              <div className="form-group">
                {documentData["56"]?.isAvailable &&
                  (() => {
                    const fileUrl = documentData["56"]?.url;
                    const fileName = documentData["56"]?.name || "";
                    const fileExt = fileName.split(".").pop()?.toLowerCase();

                    if (!fileUrl) return null;

                    return (
                      <>
                        {fileExt === "txt" && (
                          <iframe
                            src={fileUrl}
                            title="Text Preview"
                            className="preview-iframe"
                          />
                        )}
                      </>
                    );
                  })()}
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </>
    );
}

export default FrenchiseeDocumentDetailsPreview;
